var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "mtpStatusReviewedModal",
        "aria-labelledby": "exampleModalLabel",
        "data-backdrop": "static",
        "data-keyboard": "false",
        role: "dialog",
        tabindex: "-1",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          attrs: {
            role: "document",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-content",
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-header",
                },
                [
                  _vm._m(0),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        "aria-label": "Close",
                        "data-dismiss": "modal",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onClickButton()
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          attrs: {
                            "aria-hidden": "true",
                          },
                        },
                        [_vm._v("×")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._m(1),
              _c(
                "div",
                {
                  staticClass: "modal-footer",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary",
                      attrs: {
                        "data-dismiss": "modal",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onClickButton()
                        },
                      },
                    },
                    [_vm._v(" Back to review ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateChanges()
                        },
                      },
                    },
                    [_vm._v(" Update ")]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "container",
      },
      [
        _c(
          "div",
          {
            staticClass: "row",
          },
          [
            _c(
              "div",
              {
                staticClass: "col-12",
              },
              [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: {
                      id: "exampleModalLabel",
                    },
                  },
                  [_vm._v(" Update MTP status ")]
                ),
              ]
            ),
          ]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-body",
      },
      [
        _c(
          "div",
          {
            staticClass: "container",
          },
          [
            _c(
              "div",
              {
                staticClass: "row",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-12",
                  },
                  [
                    _c("p", [
                      _vm._v(
                        " The budget request has no flags and therefore needs to reflect this in the MTP status. "
                      ),
                    ]),
                    _c("p", [_vm._v('Update MTP status to "REVIEWED"?')]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }